import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import axios from 'axios';
import { useStaticQuery, graphql } from 'gatsby';
import { withLocale } from '../../../utils/hocs/withLocale';
import { returnLocalisedNodes } from '../../../utils/globals';
import {
  freeShippingMinState,
  zoneSwitcherState,
} from '../../../utils/recoil/zone';

const LOCAL_STORAGE_KEY = 'free_shipping_min';
const IP_API_ENDPOINT = 'https://api.ipify.org?format=json';

const ZoneCheck = withLocale(({ locale }) => {
  const setFreeShippingMin = useSetRecoilState(freeShippingMinState);
  const setZoneSwitcher = useSetRecoilState(zoneSwitcherState);

  const { allContentfulSettings } = useStaticQuery(
    graphql`
      query {
        allContentfulSettings {
          nodes {
            node_locale
            zones {
              title
              code
              freeShippingMin
            }
          }
        }
      }
    `
  );

  const settings = returnLocalisedNodes(
    allContentfulSettings.nodes,
    locale[0]
  )[0];

  const returnCountryInSettingsZone = (zones, code) =>
    zones.filter((zone) => zone.code === code)[0];

  // check if user is in a zone
  const checkCountryIsValidZone = (response) => {
    if (process.env.GATSBY_ZONE.toLowerCase() === 'us') {
      return (
        response.country_code.toLowerCase() ===
          process.env.GATSBY_ZONE.toLowerCase() ||
        response.country_code.toLowerCase() === 'au' ||
        response.country_code.toLowerCase() === 'nz' ||
        response.country_code.toLowerCase() === 'sg'
      );
    } else if (
      process.env.GATSBY_ZONE.toLowerCase() === 'ca' ||
      process.env.GATSBY_ZONE.toLowerCase() === 'gb'
    ) {
      return (
        response.continent_code.toLowerCase() ===
        process.env.GATSBY_ZONE.toLowerCase()
      );
    } else {
      return (
        response.country_code.toLowerCase() !== 'ca' &&
        response.country_code.toLowerCase() !== 'gb' &&
        response.country_code.toLowerCase() !== 'us' &&
        response.country_code.toLowerCase() !== 'au' &&
        response.country_code.toLowerCase() !== 'nz' &&
        response.country_code.toLowerCase() !== 'sg'
      );
    }
  };

  useEffect(() => {
    // CHECK IP ADDRESS
    if (typeof window !== 'undefined') {
      const freeShippingSessionStorage =
        window.sessionStorage[LOCAL_STORAGE_KEY];
      if (!freeShippingSessionStorage) {
        if (process.env.NODE_ENV !== 'development') {
          // ONLY request location in production
          const API_ENDPOINT =
            'https://api.ipstack.com/check?access_key=b2ab3441985cea434033182706aa756f&format=1';
          axios
            .get(API_ENDPOINT)
            .then((response) => {
              // inject locale here
              if (response.data) {
                const countryInSettingZone = returnCountryInSettingsZone(
                  settings.zones,
                  response.data.country_code
                );

                if (!checkCountryIsValidZone(response.data)) {
                  setZoneSwitcher({ active: true });
                }

                if (countryInSettingZone) {
                  setFreeShippingMin({
                    value: countryInSettingZone.freeShippingMin,
                  });
                  window.sessionStorage.setItem(
                    LOCAL_STORAGE_KEY,
                    countryInSettingZone.freeShippingMin
                  );
                } else {
                  window.sessionStorage.setItem(LOCAL_STORAGE_KEY, 64);
                  setFreeShippingMin({
                    value: 64,
                  });
                }
              }
            })
            .catch((error) => {
              console.log('Error with ipstack.com request', error);
              setFreeShippingMin({
                value: 64,
              });
            });
        } else {
          setFreeShippingMin({
            value: 64,
          });
        }
      } else {
        setFreeShippingMin({
          value: window.sessionStorage[LOCAL_STORAGE_KEY],
        });
      }
    }
  }, []);
  return <></>;
});

export default ZoneCheck;
